// An ingredient line split the way a cookbook sets it: the amount in a narrow column, the ingredient beside it
// ("2 ½ cups" | "all-purpose flour"). Only a plain leading amount is split off; anything else stays whole, as typed.
const NUMBER = String.raw`(?:\d+(?:[.,]\d+)?(?:\s*[½⅓⅔¼¾⅛⅜⅝⅞])?|[½⅓⅔¼¾⅛⅜⅝⅞]|\d+\s+\d+\/\d+|\d+\/\d+)`
const UNITS = [
  'cups?',
  'c\\.',
  'tablespoons?',
  'tbsps?\\.?',
  'tbs\\.?',
  'teaspoons?',
  'tsps?\\.?',
  'ounces?',
  'oz\\.?',
  'pounds?',
  'lbs?\\.?',
  'grams?',
  'g',
  'kg',
  'ml',
  'l',
  'liters?',
  'litres?',
  'pints?',
  'quarts?',
  'qts?\\.?',
  'gallons?',
  'sticks?',
  'cans?',
  'pinch(?:es)?',
  'dash(?:es)?',
  'cloves?',
  'packages?',
  'pkgs?\\.?',
  'slices?',
]
const AMOUNT = new RegExp(
  String.raw`^(${NUMBER}(?:\s*(?:-|–|to)\s*${NUMBER})?(?:\s+(?:${UNITS.join('|')}))?)\s+(\S.*)$`,
  'i',
)

export function splitIngredient(line: string): { amount: string; item: string } {
  const match = AMOUNT.exec(line.trim())
  if (!match) return { amount: '', item: line.trim() }
  return { amount: match[1]!.replace(/\s+/g, ' '), item: match[2]! }
}
